





































































































import { commitSetImgList } from '@/store/omr/vuex';
import { Component, Vue, Prop, Watch, Emit, Model } from 'vue-property-decorator';

@Component
export default class UploadPartDialog extends Vue {
  @Model('update:dialog', { type: Boolean, required: true })
  public readonly dialog!: boolean;

  public mydialog: boolean = false;

  @Prop({ type: Array, required: true })
  public readonly imgArr!: string[];

  @Prop({ type: String, required: true })
  public readonly scoreName!: string;

  // from 0
  @Prop({ type: Number, required: true })
  public readonly startIndex!: number;

  public endIndex: number = 0;

  public submit: boolean = false;

  public color: string = 'primary';

  @Watch('dialog')
  public onDialogOpen(val) {
    if (val) {
      this.mydialog = true;
      this.submit = false;
      this.endIndex = this.startIndex + 1;
    }
  }

  get MyImgArr() {
    return this.imgArr.slice(this.startIndex, this.endIndex);
  }

  @Watch('mydialog')
  public onMydialogClosed(val) {
    if (val === false) {
      if (this.submit) {
        commitSetImgList(this.$store, this.MyImgArr);
        this.$emit('submit', this.scoreName, this.endIndex);
        this.submit = false;
      }
      this.$emit('update:dialog', false);
    }
  }
}
